import {CompanyProps, translatedCompanyProps} from 'modules/companies/types';
import {OrderProps} from 'modules/orders/types';
import {TranslatedKeys} from 'shared/types/translated-keys';

export interface BillingProps {
  id: string;
  companyId: string;
  company: CompanyProps;
  paid: boolean;
  isClosed: boolean;
  month: string;
  startDate: Date;
  endDate: Date;
  expiresAt: Date;
  orders: OrderProps[];
  numberOfOrders: number;
  fixedCost: number;
  operationFee: number;
  advanceFee: number;

  // ORDER
  rawTotal: number;
  consideredTotal: number;

  // DELIVERIES
  paidDeliveryPrice: number;
  freeDeliveryPrice: number;
  totalDeliveryPrice: number;

  // COMPANY
  companyCouponDiscount: number;
  companyProductsDiscount: number;
  companyFreeDeliveryPrice: number;
  retainedEarningsAmount: number;
  companyAmount: number;

  // CITY
  cityCouponDiscount: number;
  cityProductsDiscount: number;
  cityFreeDeliveryPrice: number;
  cityRawAmount: number;
  cityAmount: number;

  // BALANCE
  balanceAmount: number;

  // FRANCHISE

  franchiseAmount: number;

  // OCCURRENCES
  companyOccurrences: number;
  cityOccurrences: number;
}

export const translatedBillingProps: TranslatedKeys<BillingProps> = {
  companyId: 'Empresa',
  company: {...translatedCompanyProps, name: 'Empresa'},
  paid: 'Pago?',
  isClosed: 'Fechada?',
  month: 'Mês',
  paidDeliveryPrice: 'Entregras pagas',
  rawTotal: 'Total vendido',
  consideredTotal: 'Total considerado',
  retainedEarningsAmount: 'Dinheiro com a empresa',
  cityRawAmount: 'Total cidade (Bruto)',
  balanceAmount: 'Desconto carteira',
  companyAmount: 'Total empresa',
  cityAmount: 'Total cidade',
  franchiseAmount: 'Total franquia',
  startDate: 'Data de ínicio',
  endDate: 'Data de fim',
  expiresAt: 'Vencimento',
  orders: 'Pedidos',
  numberOfOrders: 'Quantidade de pedidos',
  fixedCost: '',
  operationFee: 'Taxa de transação',
  advanceFee: 'Antecipação para o plano semanal',
  companyProductsDiscount: 'Desconto da empresa em produtos',
  cityProductsDiscount: 'Desconto da cidade em produtos',
  companyCouponDiscount: 'Desconto da empresa em cupons',
  cityCouponDiscount: 'Desconto da cidade em cupons',
  freeDeliveryPrice: 'Entrega grátis',
  totalDeliveryPrice: 'Total em entregas',
  companyOccurrences: 'Ocorrências empresa',
  cityOccurrences: 'Ocorrências cidade',
  cityFreeDeliveryPrice: 'Entrega grátis cidade',
  companyFreeDeliveryPrice: 'Entrega grátis empresa',
};
